import GeneralSettingsForm from './GeneralSettingsForm';

export default GeneralSettingsForm;
